import Head from "next/head";
import PropTypes from "prop-types";

const Seo = ({ title, desc, keywords }) => (
  <Head>
    <title>{title}</title>
    <meta content={title} name="title" />
    <meta content={title} name="og:title" property="og:title" />
    <meta content={desc} name="og:description" property="og:description" />
    <meta content={desc} name="description" />
    <meta content={keywords} name="keywords" />
    <meta content={keywords} name="og:keywords" property="og:keywords" />
  </Head>
);

Seo.propTypes = {
  desc: PropTypes.string.isRequired,
  keywords: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Seo;
